export default "__VITE_ASSET__CTLroVHd__"